import React from 'react';
import { compact } from 'lodash';
import { useSuspenseQuery } from '../../util/use_suspense_query';
import { DonutWithBars, Segment } from '../DonutWithBars/DonutWithBars';
import { Card } from '../Card/Card';
import { t } from '../../locales/translate';
import { Tooltip } from '../Tooltip/Tooltip';
import { Icon } from '../Icon/Icon';
import { NoData } from '../NoData/NoData';
import { withSuspendedCard } from '../../util/suspense';
import { graphql } from '../../generated';

const UTM_TRACKING_MEDIA = graphql(`
  query UtmTrackingMedia($id: ID!) {
    product(id: $id) {
      id
      utmTrackingStats {
        topMedia {
          nodes {
            parameter
            percentage
          }
        }
      }
    }
  }
`);

interface Props {
  productId: string;
}

const colorPalette = [
  'var(--color-chart-1)',
  'var(--color-chart-2)',
  'var(--color-chart-3)',
  'var(--color-chart-4)',
  'var(--color-chart-5)',
  'var(--color-chart-6)',
  'var(--color-chart-7)',
  'var(--color-chart-8)',
  'var(--color-chart-9)',
  'var(--color-chart-10)',
];

function UtmTrackingMediaCard$({ productId }: Props): JSX.Element {
  const { data } = useSuspenseQuery(UTM_TRACKING_MEDIA, { variables: { id: productId } });

  const topMedia = data?.product?.utmTrackingStats.topMedia.nodes || [];

  const parsedData: Segment[] = compact(
    topMedia.map(
      (node, index) =>
        node && {
          name: node.parameter || t.page.event.utmTrackingMediaCard.noUtmData,
          value: node.percentage * 100,
          color: colorPalette[index % colorPalette.length],
        }
    )
  );

  return (
    <Card
      title={t.model.event.utmTrackingMedia.title}
      tooltip={() => (
        <Tooltip
          reference={<Icon name="help--sm" color="var(--color-text-label)" />}
          position="bottom"
          fontSize="small"
          padding="medium"
          darkMode
          small
        >
          {t.model.event.utmTrackingMedia.tooltip}
        </Tooltip>
      )}
    >
      {parsedData.length > 0 ? <DonutWithBars data={parsedData} /> : <NoData />}
    </Card>
  );
}

export const UtmTrackingMediaCard = withSuspendedCard(UtmTrackingMediaCard$, {
  loadingTitle: t.model.event.utmTrackingMedia.title,
});
